// extracted by mini-css-extract-plugin
module.exports = {"login_message_box":"Vu8PD","close":"ZuBgC"};